export const environment = {
  production: false,
  apiEndpoint: 'https://app2.colloca.com.br/dev.api/index.php',
  mediaEndpoint: 'https://app2.colloca.com.br/dev.api',
  formApiUrl: 'https://app.colloca.com.br/form/submit',
  LinkContrato: 'https://colloca.com.br/wp-content/uploads/2024/01/CONTRATO-PF-Ajustado-24.01.2024.pdf',
  LinkTermos: 'https://colloca.com.br/wp-content/uploads/2024/01/Termos-de-uso-Politica-de-Privacidade-e-LGPD.pdf',
  amb: 'homol',
  path: 'homol',
};
